import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'blue' | 'green' | 'yellow' | 'orange' | 'red' | 'purple' | 'cyan';
  className?: string;
}
const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'blue',
  className = ''
}) => {
  const variantClasses = {
    blue: 'bg-blue-900/30 text-blue-400 border-blue-800/50',
    green: 'bg-green-900/30 text-green-400 border-green-800/50',
    yellow: 'bg-yellow-900/30 text-yellow-400 border-yellow-800/50',
    orange: 'bg-orange-900/30 text-orange-400 border-orange-800/50',
    red: 'bg-red-900/30 text-red-400 border-red-800/50',
    purple: 'bg-purple-900/30 text-purple-400 border-purple-800/50',
    cyan: 'bg-cyan-900/30 text-cyan-400 border-cyan-800/50'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${variantClasses[variant]} ${className}`} data-id="element-26">
      {children}
    </span>;
};
export default Badge;